import funcButtonHoverStyled from "src/utils/helper/funcButtonHoverStyled";
import { Span, StyledButton } from "./style";

const BaseBTN = ({ children, ...props }) => (
  <StyledButton {...props} onMouseMove={funcButtonHoverStyled}>
    <Span>{children}</Span>
  </StyledButton>
);

export default BaseBTN;
